import OrderPurchasePendingSockets from "./OrderPurchasePendingSockets";
import OrderPurchasePendingTimer from "./OrderPurchasePendingTimer";

export default function listenPendingPurchaseStatus(element) {
  let orderStatusDetermined = false;
  let socket;
  let timer;
  let unloadHandler;
  let pageFetchHanlder;

  function cancelOrder(orderPath) {
    return () => {
      var client;
      if (orderStatusDetermined) return;
      client = new XMLHttpRequest();
      client.open("DELETE", orderPath, false); // third parameter indicates sync xhr
      client.send();
    };
  }

  function beforeUnloadHandler(event) {
    if (orderStatusDetermined === false) {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave this page?";
      return event.returnValue;
    }
    return true;
  }

  function pageBeforeChangeHanlder(event) {
    if (!orderStatusDetermined) {
      if (!window.confirm("Are you sure you want to leave this page?")) {
        event.preventDefault();
      }
    }
  }

  function timerCancelHandler() {
    orderStatusDetermined = true;
    return true;
  }

  function initialize({ orderPath, statusPath, timeout }) {
    if (!orderPath) throw TypeError("Parameter: 'orderPath' is missing!");
    if (!statusPath) throw TypeError("Parameter: 'statusPath' is missing!");
    if (!timeout) throw TypeError("Parameter: 'timeout' is missing!");

    unloadHandler = cancelOrder(orderPath);
    pageFetchHanlder = cancelOrder(orderPath);

    window.addEventListener("beforeunload", beforeUnloadHandler);
    $(window).on("unload", unloadHandler);

    $(document)
      .on("page:before-change", pageBeforeChangeHanlder)
      .on("page:fetch", pageFetchHanlder);

    const cancelButtonEl = $("#timerCancel, #timerCancelBtn");

    $("#timerCancel, #timerCancelBtn").on("ajax:before", timerCancelHandler);

    cancelButtonEl.addClass("__disabled");
    setTimeout(() => {
      cancelButtonEl.removeClass("__disabled");
    }, 15 * 1000);

    try {
      socket = new OrderPurchasePendingSockets();
      timer = new OrderPurchasePendingTimer({
        orderEl: document.querySelector(".order-pane"),
        immediate: false,
        statusPath,
        timeout,
      });

      socket.run().then(function () {
        orderStatusDetermined = true;
      });

      timer.run().finally(function () {
        orderStatusDetermined = true;
      });
    } catch (e) {
      console.error(e);
    }
  }

  function destroy() {
    window.removeEventListener("beforeunload", beforeUnloadHandler);

    $(window).off("unload", unloadHandler);

    $(document)
      .off("page:before-change", pageBeforeChangeHanlder)
      .off("page:fetch", pageFetchHanlder);

    $("#timerCancel, #timerCancelBtn").off("ajax:before", timerCancelHandler);

    socket && socket.destroy();
    timer && timer.destroy();
  }

  destroy();
  initialize({
    orderPath: element.getAttribute("data-order-path"),
    statusPath: element.getAttribute("data-status-path"),
    timeout: element.getAttribute("data-timeout"),
  });

  return destroy;
}

window.listenPendingPurchaseStatus = listenPendingPurchaseStatus;
